import type { FormLayout, FormLayoutPage } from '../../../../../forms'
import { BasicInfoLayout } from './basic-info'
import { buildLayoutWithCommonSections, layoutFields } from './helpers'
import { NotesLayout } from './notes'

const MovingWalkLayout: FormLayoutPage = {
  key: 'moving-walk',
  title: 'Moving Walk',
  contents: [
    layoutFields.condition,
    layoutFields.accumulatedWear,
    layoutFields.design,
    layoutFields.inherentQuality,
    layoutFields.environment,
    layoutFields.technology,
    layoutFields.drivingMachineInstallYear,
    layoutFields.operationalControllerInstallYear,
    layoutFields.typeOfMotorController,
    layoutFields.hasSeismicDevices,
    layoutFields.hasMissingPalletDevice,
    layoutFields.hasLevelPalletDevice,
    layoutFields.hasCombImpactDetection,
    layoutFields.hasHandrailSpeedMonitoring,
    layoutFields.hasDriveChainDeviceSwitch,
    layoutFields.execSoftwareRevision,
    {
      ...layoutFields.drivingMachineManufacturerAndModel,
      label: 'Moving Walk Manufacturer - Model',
    },
  ],
}

export const MovingWalkFormLayout: FormLayout = buildLayoutWithCommonSections([
  BasicInfoLayout,
  MovingWalkLayout,
  NotesLayout,
])
